import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  LocationIcon,
  PhoneIcon,
  MailIcon,
  FacebookIcon,
  TwitterIcon,
  YoutubeIcon,
  ThreadsIcon,
  InstagramIcon,
  GoogleIcon,
} from "./Icons";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import EpaperModal from "./EpaperModal";

const Footer = ({ textData, pdfArticles }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalHeading, setModalHeading] = useState("Privacy Policy");
  const [isEpaperModalOpen, setIsEpaperModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenModal = (heading) => {
    setModalHeading(heading);
    setShowModal(true);
  };

  return (
    <footer className="bg-gray-900 text-gray-100 pt-10 pb-4 mt-10">
      <PrivacyPolicyModal
        open={showModal}
        onClose={() => setShowModal(false)}
        heading={modalHeading}
      />
      <EpaperModal
        pdfArticles={pdfArticles}
        open={isEpaperModalOpen}
        onClose={() => setIsEpaperModalOpen(false)}
      />
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 border-b border-gray-700 pb-8">
          <div>
            <h3 className="text-lg font-bold mb-4 text-red-400">
              {textData.footer.services}
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => setIsEpaperModalOpen(true)}
                  className="hover:text-red-300 transition"
                >
                  {textData.footer.links.epaper}
                </button>
              </li>
              <li>
                <a href="#" className="hover:text-red-300 transition">
                  {textData.footer.links.archives}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4 text-red-400">
              {textData.footer.legal}
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  className="hover:text-red-300 transition text-left"
                  style={{ textDecoration: "none" }}
                  onClick={() => handleOpenModal("Privacy Policy")}
                  type="button"
                >
                  {textData.footer.links.privacy}
                </button>
              </li>
              <li>
                <button
                  className="hover:text-red-300 transition text-left"
                  style={{ textDecoration: "none" }}
                  onClick={() => handleOpenModal("Terms of Use")}
                  type="button"
                >
                  {textData.footer.links.terms}
                </button>
              </li>
              <li>
                <button
                  className="hover:text-red-300 transition text-left"
                  style={{ textDecoration: "none" }}
                  onClick={() => handleOpenModal("Cookie Policy")}
                  type="button"
                >
                  {textData.footer.links.cookie}
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4 text-red-400">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <LocationIcon />
                Office Address: Amdavad Post Safal Sumel-8, D-314 Ajit Mill
                Cross Road, Rakhiyal Road Ahmedabad – 380023, Gujarat
              </li>
              <li className="flex items-center">
                <PhoneIcon />
                <a
                  href="tel:+919737299098"
                  className="hover:text-red-300 transition"
                >
                  +91 97372 99098
                </a>
              </li>
              <li className="flex items-center">
                <MailIcon />
                <a href="mailto:amdavadpost.in@gmail.com" className="hover:text-red-300 transition">
                  amdavadpost.in@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div className="flex flex-col h-full justify-between">
            <div>
              <h3 className="text-lg font-bold text-red-400 mb-4">
                Social Media
              </h3>
              <div className="flex space-x-4 items-center">
                <a
                  href="https://www.instagram.com/amdavadpost.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="hover:text-red-500 transition"
                >
                  <InstagramIcon />
                </a>
                <a
                  href="https://www.threads.com/@amdavadpost.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Threads"
                  className="hover:text-red-500 transition"
                >
                  <ThreadsIcon />
                </a>
                <a
                  href="https://www.facebook.com/people/Amdavad-Post/61553416502739/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="hover:text-red-500 transition"
                >
                  <FacebookIcon />
                </a>
                <a
                  href="https://x.com/Amdavadpost/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                  className="hover:text-red-500 transition"
                >
                  <TwitterIcon />
                </a>
                <a
                  href="https://www.youtube.com/@amdavadpostnews"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="hover:text-red-500 transition"
                >
                  <YoutubeIcon />
                </a>
                <a
                  href="https://share.google/bgTrveX4outq8LfHT"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Google"
                  className="hover:text-red-500 transition"
                >
                  <GoogleIcon />
                </a>
              </div>
            </div>

            <div className="mt-8 md:mt-0 flex items-center ">
              <Link
                to="/"
                onClick={(e) => {
                  if (location.pathname === "/") {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    window.dispatchEvent(new Event("closeNav"));
                    return;
                  }
                  window.dispatchEvent(new Event("closeNav"));
                  setTimeout(
                    () => window.scrollTo({ top: 0, behavior: "smooth" }),
                    60
                  );
                }}
                className="flex-shrink-0 ml-auto"
              >
                <div className="w-48 h-20 md:w-56 md:h-24 flex items-center">
                  <img
                    src="/guj_logo1.png"
                    alt="Gujarat Logo"
                    className="w-auto h-full object-contain bg-transparent cursor-pointer p-0 block"
                  />
                </div>
              </Link>

              <Link
                to="/"
                onClick={(e) => {
                  if (location.pathname === "/") {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    window.dispatchEvent(new Event("closeNav"));
                    return;
                  }
                  window.dispatchEvent(new Event("closeNav"));
                  setTimeout(
                    () => window.scrollTo({ top: 0, behavior: "smooth" }),
                    60
                  );
                }}
                className="flex-shrink-0"
              >
                <div className="w-44 h-16 md:w-52 md:h-20 -ml-2 md:-ml-3 flex items-center">
                  <img
                    src="/AP_Still.png"
                    alt="Amdavad Post Logo"
                    className="w-auto h-full object-contain bg-transparent cursor-pointer p-0 block"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center pt-6 text-xs text-gray-400">
          <span>{textData.footer.copyright}</span>
          <span>Developed by <a href="https://arhamcorp.in" target="_blank" rel="noopener noreferrer" className="font-bold">Arham Corporation</a></span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
